export default __webpack_public_path__ + "static/media/googleplay-badge.84443542.svg";